import { Button } from '@sureco/design-system'
import { Modal, Typography, message } from 'antd'
import { createZendeskTicket } from 'enrollment-platform/pages/HRIS/api/hris-api-client'
import { isProduction } from 'modules/app-config/environment'
import React, { useState } from 'react'
const { Link } = Typography

export const ZendeskCellRenderer = ({
  data,
  onSendComplete,
}: {
  data: any
  onSendComplete: () => void
}) => {
  const [isSending, setIsSending] = useState(false)
  const [isSendConfirmOpen, setIsSendConfirmOpen] = useState(false)
  const ticketId = data?.zdTicketNumber
  const reportId = data?.id
  const generatedFiles = data?.generatedFiles || []
  const hasOnlyErrors =
    generatedFiles.length > 0 && generatedFiles.every((file) => file.isError)

  const allNonErrorSubmitted = generatedFiles
    .filter((file) => !file.isError)
    .every((file) => file.isSubmitted)

  const enableSend =
    generatedFiles.length > 0 && (hasOnlyErrors || allNonErrorSubmitted)

  const zendeskDomain = isProduction()
    ? 'sureco.zendesk.com'
    : 'surecodev.zendesk.com'

  const handleSendZendesk = async () => {
    try {
      setIsSending(true)
      await createZendeskTicket(reportId)
      message.success('Zendesk Ticket created successfully')
      onSendComplete?.()
    } catch (err) {
      message.error('Failed to create Zendesk ticket')
    } finally {
      setIsSending(false)
      setIsSendConfirmOpen(false)
    }
  }

  return ticketId ? (
    <div>
      <Link
        href={`https://${zendeskDomain}/agent/tickets/${ticketId}`}
        target="_blank"
        rel="noopener noreferrer"
        className="textSm textGray"
      >
        #{ticketId}
      </Link>
      <br />
      Status: {data?.zendeskTicketStatus}
    </div>
  ) : (
    <>
      <Button
        disabled={!enableSend || isSending}
        loading={isSending}
        onClick={() => setIsSendConfirmOpen(true)}
        style={{ marginLeft: 'auto' }}
      >
        Send
      </Button>
      <Modal
        title="Send this report to Zendesk?"
        open={isSendConfirmOpen}
        okText="Send"
        cancelText="Cancel"
        confirmLoading={isSending}
        onOk={handleSendZendesk}
        onCancel={() => setIsSendConfirmOpen(false)}
        okButtonProps={{
          disabled: !enableSend,
        }}
      >
        Are you sure you want to create a Zendesk ticket for this report?
      </Modal>
    </>
  )
}

export default ZendeskCellRenderer
